module.exports = __webpack_public_path__ + "static/media/ALevel_edexcel_logo.6366f690.jpg";